import { ApplicationConfig, importProvidersFrom } from '@angular/core'
import { provideRouter } from '@angular/router'
import { routes } from './app.routes'
import { BrowserModule } from '@angular/platform-browser'
import { CommonModule } from '@angular/common'
import { provideAnimations } from '@angular/platform-browser/animations'
import { FormsModule } from '@angular/forms'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { generateUuidV4, GlobalHttpInterceptor, UUID_TOKEN } from './services/app-global-http-interceptor.service'
import { ToastrModule } from 'ngx-toastr'
import { CookieModule, CookieService } from 'ngx-cookie'
import { BASE_PATH } from '@idp-education/ors-test-taker-bff-client-v1'
import { BASE_PATH as BASE_PATH_V2 } from '@idp-education/ors-test-taker-bff-client-v2'
import { environment } from 'src/environments/environment'
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask'

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes),
    importProvidersFrom(BrowserModule, CommonModule, FormsModule, ToastrModule.forRoot(),
    CookieModule.withOptions(), NgxMaskDirective, NgxMaskPipe
    ), CookieService,
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptor, multi: true },
    { provide: BASE_PATH, useValue: environment.ttBaseURL },
    { provide: BASE_PATH_V2, useValue: environment.ttBaseURL },
    { provide: UUID_TOKEN, useFactory: generateUuidV4 },
    provideNgxMask()
  ]
}
